import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Clouds = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.BgColor ? "0 0 105 104" : "0 0 20 20"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={props.size}
            height={props.size}>
            {props.BgColor ? <rect x="0.5" width="104" height="104" rx="50" fill={props.BgColor} /> : null}
            <path d="M9.80594 1H10C12.7614 1 15 3.23858 15 6V7H15.5C17.433 7 19 8.567 19 10.5C19 12.433 17.433 14 15.5 14H5.5C3.01472 14 1 11.9853 1 9.5V8.75564C1 6.68146 2.68146 5 4.75564 5C4.89925 5 5.02444 4.90226 5.05927 4.76294L5.07692 4.69231C5.61942 2.52231 7.56917 1 9.80594 1Z"
                stroke={props.color ? props.color : "#0076A8"}
                strokeWidth={props.strokeWidth ? props.strokeWidth : "1.5"}
                strokeLinecap="round"
                strokeLinejoin="round" />
        </SvgStyled>
    );
};

export default Clouds;
